export default "__VITE_ASSET__BdNKQ1X___"